import { buildMapUrl } from '../lib/mapUrl';
import './LocationLink.css';

interface LocationLinkProps {
  location: string;
  placeId?: string | null;
  className?: string;
}

/**
 * Render a location as a link that opens it in Google Maps in a new tab
 * (preferring the placeId for an exact match). Falls back to plain text for an
 * empty location.
 */
export function LocationLink({ location, placeId, className = '' }: LocationLinkProps) {
  const url = buildMapUrl(location, placeId);
  if (!url) return <span className={className}>{location}</span>;
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className={`location-link ${className}`}
      title="Open in Google Maps"
      onClick={(e) => e.stopPropagation()}
    >
      {location}
    </a>
  );
}
